import { render } from "./farmingDetail.vue?vue&type=template&id=1025b564&scoped=true&ts=true"
import script from "./farmingDetail.vue?vue&type=script&lang=ts"
export * from "./farmingDetail.vue?vue&type=script&lang=ts"

import "./farmingDetail.vue?vue&type=style&index=0&id=1025b564&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1025b564"]])

export default __exports__